import { useMutation, useQueryClient } from '@tanstack/react-query';
import { signUpWithOAuth, type SignUpWithOAuthParams } from '../../api';
import { identifyDataLayerUser } from '@/shared/analytics';

export function useSignUpWithOAuth() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: SignUpWithOAuthParams) => signUpWithOAuth(params),
    onSuccess: (user) => {
      identifyDataLayerUser(user.id);
      return queryClient.invalidateQueries({ queryKey: ['me'] });
    },
  });
}
